<template>
  <v-container fluid pa-3 background  class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="SearchData"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
     <filter-component :json_data ="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

     <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top >
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer" v-if="permission_edit == true || admin == 'true'">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:40px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddCheckInOut')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('AddCheckInOut')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading" >
          <v-flex lg12 md12 sm12 xs12 pa-1  v-for="(item, index) in table_data" :key="index" @click="''" >
            <v-card class="coco-box-shadow " style="border-left:5px solid #408550">
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg2 md2 sm2 xs2 class="hidden-xs-only hidden-sm-only">
                  <span>
                    <v-icon color="#408550" class="coco-label-icon">alarm</v-icon>
                    </span>
                   
                   <span class="coco-list-label-icon ">
                        <span>{{dateformat(item.check_date)}}</span>
                      </span>
                  <!-- <v-avatar :size="64">
                    <v-avatar
                      v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                      :size="64"
                      color="teal"
                    >
                      <span class="white--text headline">{{item.nick_name}}</span>
                    </v-avatar>

                    <Empimage
                      v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                      :json_data="item.emp_images"
                    />
                  </v-avatar> -->
                </v-flex>
                <v-flex lg9 md7 sm9 xs12>
                  <v-layout row wrap>
                     <v-flex lg2 md6 sm6 xs6 class="hidden-xl-only hidden-lg-only hidden-md-only">
                      <span >
                        <strong>{{dateformat(item.check_date)}}</strong>
                      </span>
                    </v-flex>
                    <v-flex lg1 md12 sm6 xs6>
                      <span >
                        <span style="color:#408550;">{{item.check_time}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg2 md6 sm6 xs6>
                      <span >{{isEmpty(item.usercode)? item.usercode : 'emp_code'}}</span>
                      
                    </v-flex>
                     <v-flex lg3 md6 sm6 xs6>
                      <span>{{item.firstName}} {{item.lastName}}</span>
                      <span v-if="!(isEmpty(item.nick_name))"></span>
                       <span v-if="isEmpty(item.nick_name)" v-html="' (<span style=color:#166BFF;>'+(item.nick_name)+'</span>)'"/>
                    </v-flex>
                     <v-flex lg2 md6 xs6>
                      <span class=" hidden-sm-only">
                        {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branch_name)? item.branch_name
                          : 'branch'}}
                        </span>
                      </span>
                      
                    </v-flex>
                    <v-flex lg2 md6 xs6>
                      <span class=" hidden-sm-only">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.department_name) ?
                          item.department_name : 'department_name'}}
                        </span>
                      </span>
                      
                    </v-flex>

                     <!-- <v-flex lg3 xs12 md12 sm12  class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branch)? item.branch
                          : 'branch'}}
                        </span>
                      </span>
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.department_name) ?
                          item.department_name : 'department_name'}}
                        </span>
                      </span>
                      
                    </v-flex> -->

                    <!-- <v-flex xs12 md12 sm12  class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Position')}}:
                        <span>
                          {{isEmpty(item.position) ?
                          item.position : 'position'}}
                        </span>
                      </span>
                    </v-flex> -->

                    <v-flex lg2 xs12 md12 sm12  class="hidden-xs-only">
                    
                      <span >
                        <!-- <v-icon>assignment</v-icon> -->
                        <span>{{isEmpty(item.doc_no) ? item.doc_no : "doc_no"}}</span>
                      </span>
                      <span
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                      <!-- <span class="coco-list-label-icon">
                        <v-icon>access_time</v-icon>
                        <span>{{formatDate(item.check_in_time, formatDates)}}</span>
                      </span>
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span> -->
                    </v-flex>

                   
                  </v-layout>
                </v-flex>
                <v-flex lg1 md2 sm2 xs4 class="hidden-xs-only ">
                  <v-layout row wrap >
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap >
                        <v-flex lgุ12 md12 style="margin-top:-15px;" v-if="permission_edit == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex offset-xs8 xs4 class="hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex xs12 v-if="permission_edit == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout row wrap my-2>
      <v-flex xs12>
        <div class="show_pagination_fixed" >
          <v-pagination fixed v-model="pageActive" :length="totalPages" :total-visible="5" circle  @input="getCheckinoutList"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card >
            <v-toolbar dark color="blue d-1">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="padding:15px !importtant;">
              <v-layout row wrap>
                <v-flex xs12 pa-3>
                    ต้องการลบข้อมูลเวลาของ
              <br>
              {{delDialog.name}}
              <br>
              {{delDialog.time}} ใช่หรือไม่?
                </v-flex>
              </v-layout>
            
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog"/>
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import FrmDialog from "./FormDialog";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import $ from "jquery";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";
import moment from "moment";

export default {
  data: () => ({
    SearchData: "",
    show_search: false,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    totalPages:0,
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      time: ""
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
     form_dialog_data: {
      status: false,
       },
    permission_edit:false,
    permission_view:false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),
  created:async function() {
    this.admin = localStorage._is_admin;
      await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
     await this.checkpermission("CheckInOutList");
    console.log(this.check_permission)
    // this.setShowFilter({
    //   status: 0
    // });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.getCheckinoutList();
    this.getEmployee("newData");

    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.SearchData;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getCheckinoutList();
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FrmDialog,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading", "formatDates"]),
    ...mapState("filter", ["Employee_List"]),
   // ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
       ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog () { 
      this.getCheckinoutList();
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      
    },
      checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getCheckinoutList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    onHandleAlert(status, message) {
      this.alert_data = {
        status: true,
        message: err
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    // onScrollFunction(e) {
    //   let win_scroll_top = e.target.defaultView.pageYOffset;
    //   let win_height = window.innerHeight;
    //   let doc_height = document.body.scrollHeight;
    //   // console.log("win_scroll_top " + win_scroll_top);
    //   // console.log("win_scroll " + win_height);
    //   // console.log("win_scroll " + doc_height);
    //   if (win_scroll_top >= (doc_height - win_height) * 0.99) {
    //     if (!this.processing && this.canLoadMore) {
    //       this.pageActive += 1;
    //       console.log('dddddd', this.pageActive)
    //       this.getCheckinoutList();
    //     }
         
    //   }
    // },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getCheckinoutList();
      }, 1500);
    },
    getCheckinoutList() {
      this.commitSetShowLoading(true);
      let search = '';
      DocumentService.getCheckinoutList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.SearchData,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then(res => {
          if (this.table_data.length > 0) {
            if (res.data.content.length > 0 ) {
                this.table_data= [];
              res.data.content.forEach(data => {
                this.table_data.push(data);
               
              });
              this.totalPages = res.data.totalPages;
            //this.tabledata = res.entity;
            console.log(res.data.totalPages);
            this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
            console.log(this.table_data)
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.usercode+" "+ data.firstName + data.lastName;
      this.delDialog.time = this.dateformat(data.check_date) +" "+ data.check_time;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteCheckinTime(this.delDialog.roworder)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getCheckinoutList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          console.log(err);

          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    // onScrollFunction(e) {
    //   let win_scroll_top = e.target.defaultView.pageYOffset;
    //   let win_height = window.innerHeight;
    //   let doc_height = document.body.scrollHeight;

    //   console.log("win_scroll_top " + win_scroll_top);
    //   let width = $(".contain_width").width();
    //   //console.log("width " + width);
    //   if (win_scroll_top > 100) {
    //     $(".search_in_page").show();
    //     $(".search_in_page").css("width", width);
    //   } else {
    //     $(".search_in_page").hide();
    //   }
    //    if (win_scroll_top >= (doc_height - win_height) * 0.99) {
    //     if (!this.processing && this.canLoadMore) {
    //       this.pageActive += 1;
    //       //this.getEmployeeList('List');
    //       console.log('last');
    //     }
    //     if(this.processing && this.canLoadMore){
    //       console.log('not last');
    //     }
    //    }
    // },
      showFilter(status){
      this.form_dialog_data = {
        status: status,
        data:1
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
      dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    timeformat(time) {
      return moment(time).format('LT');
    },
  }
};
</script>


